import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyC0w92qcIp9MNPyR24KCqqTdIZv_FHEDN8",
  authDomain: "edotco-1fd4c.firebaseapp.com",
  projectId: "edotco-1fd4c",
  storageBucket: "edotco-1fd4c.firebasestorage.app",
  messagingSenderId: "117506187339",
  appId: "1:117506187339:web:66f84e320ffe0fa2d9adce",
  measurementId: "G-DDEFQRVV92",
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export const generateToken = async () => {
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    const token = await getToken(messaging, {
      vapidKey:
        "BDdk7K6lcWoWdoiwpk8_oVn7s9SDjeo0qrkBuuy_-DdKp48kg5geKS4e-7pAqmocDqsvFLocVb0LjqS8tIPDEnk",
    });

    return token;
  }
};
